<nb-user
  *ngIf="mode == 'avatar'"
  [picture]="imageURL"
  onlyPicture
  size="large"
  (click)="viewProfile(uid)"
  class="link"
></nb-user>

<a *ngIf="mode == 'name'" (click)="viewProfile(uid)" class="link">
  <nb-icon *ngIf="icon && icon != ''" [icon]="icon"></nb-icon>
  <strong>
    {{ name }}
  </strong>
</a>
